import React, { useState, useEffect } from 'react'
import './GameSummary.css'
import { useParams } from 'react-router-dom'
import Footer from '../UIElements/Footer'
import badgersLogo from '../../../shared/components/images/Badgers_Logo2.PNG'

const GameSummaryWarning = () => {
	const [isLoading, setIsLoading] = useState(false)
	const [error, setError] = useState()
	const [loadedGame, setLoadedGame] = useState()
	const [loadedGameStats, setLoadedGameStats] = useState()
	const [winner, setWinner] = useState()
	const gameId = useParams().gameId
	const [homeRoster, setHomeRoster] = useState()
	const [rosterPlayerGameStats, setRosterPlayerGameStats] = useState()
	const [opponent, setOpponent] = useState()
	const [venue, setVenue] = useState()

	// goes to backend, admin-controller, getGameData

	//
	//
	//
	//
	//
	return (
		<React.Fragment>
			{/* <div>
				<img src={badgersLogo} className='badgersLogo' />
			</div> */}

			<h3 className='h3Center' style={{ marginTop: '15rem' }}>
				Stop creepin'. You gotta be logged in to see game summary's!
			</h3>
			<div className='warningFooter'>
				<Footer />
			</div>
		</React.Fragment>
	)
}

export default GameSummaryWarning
